module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_landing_6_.aa7bc0a2.png";